import { createI18n } from "vue-i18n";

let userAgent = JSON.parse(localStorage.getItem("IST_USER_AGENT"));
let browserLanguage = navigator.language.toLocaleLowerCase();
if (browserLanguage == "zh-tw" || browserLanguage == "zh-hk") {
  browserLanguage = "zh-TW";
} else {
  if (browserLanguage.includes("-")) {
    browserLanguage = browserLanguage.split("-")[0];
  }
}
const i18n = createI18n({
  locale: browserLanguage,
  globalInjection: true,
  fallbackLocale: "en-US",
  messages: {
    zh: require("./zh-CN.json"),
    en: require("./en-US.json"),
    "zh-TW": require("./zh-TW.json"),
    it: require("./it-IT.json"),
    ar: require("./ar-AE.json"),
    es: require("./es-ES.json"),
    fr: require("./fr-FR.json"),
    de: require("./de-DE.json"),
    pt: require("./pt-PT.json"),
    ko: require("./ko-KR.json"),
    ja: require("./ja-JP.json"),
    nl: require("./nl-NL.json"),
  },
});

export default i18n;
